var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFadeIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fadeIn_svg__Thumbnail_Pro fadeIn_svg__Gallery fadeIn_svg__Animations_Scroll_Fade fadeIn_svg__In"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3885FF",
    d: "M45 28v13c0 1.1-.9 2-2 2H26V30c0-1.1.9-2 2-2h17z",
    className: "fadeIn_svg__illus-clr-2",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80B1FF",
    d: "M50 28h-5v13c0 .74-.4 1.37-.99 1.72.15-.09.29-.18.41-.31-.12.12-.26.22-.41.31-.04.02-.07.04-.11.06a1.81 1.81 0 01-.89.22H26v5c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V30c0-1.1-.9-2-2-2zm-6.11 14.78c-.15.08-.31.14-.49.18.17-.04.33-.1.49-.18zM26 30v13h-5c-1.1 0-2-.9-2-2V23c0-1.1.9-2 2-2h22c1.1 0 2 .9 2 2v5H28c-1.1 0-2 .9-2 2z",
    className: "fadeIn_svg__illus-clr-1",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E6FF",
    d: "M39.57 36h-15c-.81 0-1.28-.85-.81-1.47l3.17-4.14c.36-.47 1.08-.52 1.51-.12l2.49 2.33 2.89-4.17c.38-.55 1.21-.58 1.63-.06l4.91 6.07c.51.63.04 1.56-.79 1.56z",
    className: "fadeIn_svg__illus-clr-3",
    opacity: 0.8
  }))));
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='72' height='72' fill='none' viewBox='0 0 72 72'%3e %3cg class='Thumbnail_Pro Gallery Animations_Scroll_Fade In'%3e %3cpath fill='%233885FF' d='M45 28v13c0 1.1-.9 2-2 2H26V30c0-1.1.9-2 2-2h17Z' class='illus-clr-2' opacity='.65'/%3e %3cpath fill='%2380B1FF' d='M50 28h-5v13c0 .74-.4 1.37-.99 1.72.15-.09.29-.18.41-.31-.12.12-.26.22-.41.31-.04.02-.07.04-.11.06a1.81 1.81 0 0 1-.89.22H26v5c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V30c0-1.1-.9-2-2-2Zm-6.11 14.78c-.15.08-.31.14-.49.18.17-.04.33-.1.49-.18ZM26 30v13h-5c-1.1 0-2-.9-2-2V23c0-1.1.9-2 2-2h22c1.1 0 2 .9 2 2v5H28c-1.1 0-2 .9-2 2Z' class='illus-clr-1' opacity='.7'/%3e %3cpath fill='%23D6E6FF' d='M39.57 36h-15c-.81 0-1.28-.85-.81-1.47l3.17-4.14c.36-.47 1.08-.52 1.51-.12l2.49 2.33 2.89-4.17c.38-.55 1.21-.58 1.63-.06l4.91 6.07c.51.63.04 1.56-.79 1.56Z' class='illus-clr-3' opacity='.8'/%3e %3c/g%3e %3c/svg%3e";
export { SvgFadeIn as ReactComponent };